import { useLingui } from '@lingui/react/macro';
import {
  PostApiTimesheetsByUuidSubmitAsyncError,
  PostApiTimesheetsByUuidSubmitAsyncResponse,
  PostApiTimesheetsByUuidSubmitAsyncVariables,
  usePostTimesheetSubmitAsync as usePostApiTimesheetsByUuidSubmitAsync,
} from '@sit/client-shared';
import { UseMutationOptions } from '@tanstack/react-query';
import toastr from '@web/helpers/toastr';

export const usePostTimesheetSubmitAsync = (
  options?: Omit<
    UseMutationOptions<
      PostApiTimesheetsByUuidSubmitAsyncResponse,
      PostApiTimesheetsByUuidSubmitAsyncError,
      PostApiTimesheetsByUuidSubmitAsyncVariables
    >,
    'mutationFn'
  >,
) => {
  const { t } = useLingui();
  return usePostApiTimesheetsByUuidSubmitAsync({
    onSuccess: async (data, variables, onMutateResult, context) => {
      const timesheetId = variables.pathParams.id;
      await options?.onSuccess?.(data, variables, onMutateResult, context);
      toastr.info(t`Submitting your timesheet, we'll notify you when we finish.`, {
        toastId: timesheetId,
      });
    },
  });
};
